import { SERVICES } from "@/Pages/Website/Home/HeroV2";

// WebMCP (W3C draft CG spec, Feb 2026) — lets a supporting browser/agent call
// site functionality directly as typed tools instead of scraping the DOM.
// Only available behind a flag in Chrome 146 Canary today, so this is
// entirely opt-in and must no-op everywhere else.
export function registerWebMcpTools() {
    if (typeof navigator === "undefined" || !navigator.modelContext) return;

    navigator.modelContext.registerTool({
        name: "search_services",
        description:
            "Search Wiz Freelance's digital marketing and web development services by keyword (Arabic or English). Returns matching services with their page URL.",
        inputSchema: {
            type: "object",
            properties: {
                query: {
                    type: "string",
                    description: "Keyword to match against service names, e.g. \"سيو\" or \"تصميم موقع\"",
                },
            },
            required: ["query"],
        },
        annotations: { readOnlyHint: true },
        async execute(input) {
            const q = (input.query || "").trim().toLowerCase();
            const matches = (q ? SERVICES.filter((s) => s.name.toLowerCase().includes(q)) : SERVICES).map(
                (s) => ({
                    name: s.name,
                    url: `https://wizfreelance.com/services/${s.slug}`,
                })
            );
            return { services: matches };
        },
    });

    navigator.modelContext.registerTool({
        name: "submit_contact_inquiry",
        description:
            "Submit a contact/lead inquiry to Wiz Freelance on behalf of the user. Use only after the user has explicitly confirmed their details and wants to send the message.",
        inputSchema: {
            type: "object",
            properties: {
                first_name: { type: "string" },
                last_name: { type: "string" },
                email: { type: "string", description: "Contact email address" },
                phone: { type: "string", description: "Phone number, e.g. +966..." },
                company: { type: "string", description: "Optional company name" },
                message: { type: "string", description: "The inquiry message" },
            },
            required: ["first_name", "last_name", "email", "phone", "message"],
        },
        annotations: { readOnlyHint: false },
        async execute(input) {
            await window.axios.post("/contact", input);
            return { status: "sent" };
        },
    });
}
